if (!customElements.get('planted-header-badge')) {
  class PlantedHeaderBadge extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button')
      const id = this.getAttribute('data-id')
      const self = this

      if (!id || localStorage.getItem(`hide_badge_${id}`) !== 'true') {
        this.style.display = ''
      }
      if (button) {
        button.addEventListener('click', function () {
          localStorage.setItem(`hide_badge_${id}`, 'true')
          self.style.display = 'none'
        })
      }
    }
  }
  customElements.define('planted-header-badge', PlantedHeaderBadge)
}
